<template>
    
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">{{ title }}</h5>
            <div class="d-flex justify-content-between">
                <div class="display-6">
                    {{ amount | localizeNumber }}
                </div>
                <div class="">
<!--                @todo    <span class="badge bg-success text-white">
                        {{ growth | localizePercent }}
                        <i class="bi bi-chevron-up"></i>
                    </span>
                    <span class="badge bg-danger text-white">
                        {{ growth | localizePercent }}
                        <i class="bi bi-chevron-down"></i>
                    </span>-->
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {
        props: {
            title: String,
            amount: [String, Number],
            growth: [String, Number],
        }
    }
</script>

<style scoped>

</style>
